import { PropsWithChildren } from 'react';
import EmailVerification from '../components/atoms/EmailVerification';
import Dialog from '@mui/material/Dialog';
import { useUserData } from '../queries';
import { useEmailVerification } from '../hooks/useEmailVerification';

const EmailVerificationGuard = ({ children }: PropsWithChildren) => {
  const { data: userData } = useUserData();
  const shouldVerify = useEmailVerification('onLogin');

  if (shouldVerify) {
    return (
      <Dialog open>
        <EmailVerification email={userData?.email} />
      </Dialog>
    );
  }

  return <>{children}</>;
};

export default EmailVerificationGuard;
